type DefaultMultiCartSummary = App.MultiCartSummary & { type: 'default' }
type SharedMultiCartSummary = App.MultiCartSummary & { type: 'shared' }
type TripPlannerMultiCartSummary = App.MultiCartSummary & { type: 'trip_planner' }
export type VisibleUserCartMultiCartSummary = DefaultMultiCartSummary | SharedMultiCartSummary

export function isDefaultMultiCart(cart: App.MultiCartSummary | undefined): cart is DefaultMultiCartSummary {
  return cart?.type === 'default'
}

export function isSharedMultiCart(cart: App.MultiCartSummary | undefined): cart is SharedMultiCartSummary {
  return cart?.type === 'shared'
}

export function isTripPlannerMultiCart(cart: App.MultiCartSummary | undefined): cart is TripPlannerMultiCartSummary {
  return cart?.type === 'trip_planner'
}

export function isVisibleUserCartMultiCart(cart: App.MultiCartSummary | undefined): cart is VisibleUserCartMultiCartSummary {
  return isDefaultMultiCart(cart) || isSharedMultiCart(cart)
}

export function filterVisibleUserCartMultiCarts(carts: Array<App.MultiCartSummary>): Array<VisibleUserCartMultiCartSummary> {
  return carts.filter(isVisibleUserCartMultiCart)
}
